import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { canAccessMenu } from "@/lib/permissions";

export function RequireUser({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

export function RequireAdmin({ children, superOnly = false, menu = null }) {
  const { admin } = useAuth();
  if (!admin) return <Navigate to="/" replace />;
  if (superOnly && !admin.isSuperAdmin) return <Navigate to="/admin" replace />;
  if (menu && !canAccessMenu(admin, menu)) return <Navigate to="/admin" replace />;
  return children;
}
